import Modal from 'react-bootstrap/Modal';
import { IoClose } from 'react-icons/io5';
import modalStyles from '../../css/style.module.css';
import { getDownloadSummary } from './timesheetFilterUtils';
import downloadStyles from './TimesheetDownloadModal.module.css';

const TimesheetDownloadModal = ({
  show,
  onHide,
  status,
  fromDate,
  toDate,
  downloading,
  onConfirm,
}) => {
  const { statusLabel, fromDateLabel, toDateLabel, dateRangeLabel } = getDownloadSummary(
    status,
    fromDate,
    toDate
  );

  return (
    <Modal show={show} onHide={onHide} size="sl" centered>
      <Modal.Body>
        <div className={modalStyles.modaldownload}>
          <div className={modalStyles.modaldownloadheading}>
            <h6>{downloading ? 'Downloading Timesheet' : 'Confirm Download'}</h6>
            {!downloading && <IoClose color="#000000" size={25} onClick={onHide} />}
          </div>

          <div className={downloadStyles.summaryBox}>
            {downloading ? (
              <p className={downloadStyles.message}>
                Downloading timesheet data for <strong>{statusLabel}</strong> status from{' '}
                <strong>{fromDateLabel}</strong> to <strong>{toDateLabel}</strong>.
              </p>
            ) : (
              <>
                <p className={downloadStyles.message}>
                  You are about to download timesheet data with the following filters:
                </p>
                <div className={downloadStyles.detailRow}>
                  <span>Status</span>
                  <strong>{statusLabel}</strong>
                </div>
                <div className={downloadStyles.detailRow}>
                  <span>Date Range</span>
                  <strong>{dateRangeLabel}</strong>
                </div>
              </>
            )}
          </div>

          {!downloading && (
            <div className={modalStyles.modaldownloadbutton}>
              <button type="button" onClick={onConfirm}>
                Download
              </button>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TimesheetDownloadModal;
